<template>
  <div class="tools-partners-profiles">
    <snow-data-table-header
      v-if="profiles.length"
      @add="add"
      addText="Adicionar Perfil"
      :filters="false"
      :datePicker="false"
      @searching="onSearch"
    />

    <div v-if="loading" class="text-center my-9">
      <b-spinner variant="primary" />
    </div>

    <snow-data-table v-else :data="_profiles" :columns="columns">
      <template #no-content-actions>
        <div class="d-flex flex-column align-items-center text-center gap-4">
          <snow-button icon="ph ph-plus" text="Cadastrar perfil" @click="add" />
          <h6 class="text-dark-40">
            Divida seus colaboradores por perfil, liberando permissões de acordo
            com o papel de cada um
          </h6>
        </div>
      </template>
      <template #permissões="{ value }">
        <snow-table-permissions :permissions="value.map(formatPermission)" />
      </template>
    </snow-data-table>

    <div v-if="!loading" class="d-flex justify-content-end mt-4">
      <snow-paginator
        v-model="page"
        :pagination="pagination"
        @change-page="dispatch"
      />
    </div>
  </div>
</template>

<script>
import get from "lodash/get";
import { mapState } from "vuex";
import SnowTablePermissions from "@/components/snow-ui/dataTable/SnowTablePermissions.vue";

export default {
  components: { SnowTablePermissions },
  data() {
    return {
      search: "",
      loading: false,
      page: 1,
      pagination: {
        count: 0,
        next: "",
        previous: ""
      }
    };
  },
  computed: {
    ...mapState("partnersCenter", ["profiles", "permissions"]),
    _profiles() {
      return this.profiles.map(profile => ({
        ...profile,
        scope: Object.keys(profile.scope)
      }));
    },
    _permissions() {
      return this.permissions.reduce(
        (prev, cur) => [...prev, ...cur.permissions],
        []
      );
    },
    columns() {
      return [
        {
          name: "Perfil",
          field: "name"
        },
        {
          name: "Permissões",
          field: "scope"
        },
        {
          name: "",
          type: "menu",
          options: this.actions
        }
      ];
    }
  },
  mounted() {
    this.loading = true;

    Promise.all([
      this.$store.dispatch("partnersCenter/getPermissions"),
      this.dispatch()
    ]).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    formatPermission(permission) {
      return permission
        ? get(
            this._permissions.find(p => p.code === permission),
            "name",
            "Erro"
          )
        : "Erro";
    },
    actions(item) {
      return [
        {
          label: "Editar",
          click: this.edit
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text: "Tem certeza que deseja excluir este perfil?",
            icon: "ph ph-trash",
            buttonText: "Sim, excluir",
            action: this.remove,
            secondaryButtonText: "Não, cancelar"
          }
        }
      ];
    },
    edit(item) {
      this.$router.push({
        name: "tools-partners-profile",
        query: { id: item.id }
      });
    },
    add() {
      this.$router.push({
        name: "tools-partners-profile"
      });
    },
    dispatch(offset = null) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/getProfiles", { search: this.search, offset })
        .then(({ count, next, previous }) => {
          this.pagination = { count, next, previous };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch(search) {
      this.search = search;
      this.dispatch();
    },
    remove(item) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/deleteProfile", item.id)
        .then(() => {
          this.dispatch();
          this.$message.success("Perfil removido");
        })
        .catch(() => {
          this.$message.error("Erro ao remover perfil");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tools-partners-profiles {
  .event-button {
    padding: 2px 8px;
  }
}
</style>
